import React from 'react';
import cx from 'classnames';
import Card from '../Card';
import StepHeader from './Header';
import style from './stepper.module.scss';

const Stepper = ({ currentStep = 0, steps = [], showStepHeader = true, isHeaderClickActive, customContentClass, onCurrentStepChange }) => {
	const handleOnStepClick = index => {
		if (index !== currentStep && index !== steps?.length - 1) {
			onCurrentStepChange?.(index);
		}
	};

	return (
		<>
			{showStepHeader && <StepHeader steps={steps} currentStep={currentStep} isHeaderClickActive={isHeaderClickActive} onStepClick={handleOnStepClick}/>}
			<Card customContentClass={cx(style.content, customContentClass)} title={steps?.[currentStep]?.header}>
				{steps?.map((step, index) => {
					const StepComponent = step?.component;
					return index === currentStep && step?.component && <StepComponent key={index} />;
				})}
			</Card>
		</>
	);
};

export default Stepper;
